import { ChangeDetectionStrategy, Component, input, inject } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormControl } from '@angular/forms';
import { ErrorMessageService } from '@app/shared/services/material-error-message.service';
import { AceModule } from 'ngx-ace-wrapper';
import 'brace';
import 'brace/mode/json';
import 'brace/theme/monokai';

@Component({
  selector: 'inspekt-form-schema-editor',
  templateUrl: 'form-schema-editor.component.html',
  styleUrls: ['form-schema-editor.component.scss'],
  styles: [':host { display: block; width: 100%; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AceModule, MatFormFieldModule]
})

export class FormSchemaEditorComponent {
  private errorMessageService = inject(ErrorMessageService);

  readonly control = input<FormControl>(undefined);
  readonly title = input<string>();

  onChange(jsonString: string) {
    this.control().setValue(jsonString);
  }

  public getErrorMessage() {
    return this.errorMessageService.getErrorMessageUsingFormControl(this.control());
  }

}
